import AppRouter from './router';
import { ToastProvider } from './components/Toast';
import { VersionBanner } from './components/VersionBanner';
import './styles/App.css';
// Screen.css carries the .toast / .skeleton / .empty-state primitive
// rules. Most screens already import it, but loading it at App-level
// guarantees the toast stack styles are present even before a screen
// mounts (e.g. for splash/error states).
import './styles/Screen.css';

function App() {
  return (
    <ToastProvider>
      <AppRouter />
      <VersionBanner />
    </ToastProvider>
  );
}

export default App;
